<template>
  <Modal title="编辑买断时间" v-model="visible" :width="600"  :mask-closable="false" v-drag-modal>
    <Form ref="timeForm" class="form" :label-width="90"
      :model="timeParam" :rules="timeRule">
      <Row>
        <Col :span="26" >
          <Form-item label="选择买断时间" prop="openedTime">
            <Row :gutter="12">
              <Col :span="4">
                <Form-item prop="week">
                  <Select placeholder="星期" v-model="timeParam.week" transfer>
                    <Option v-for="item in $constant.week"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
                  </Select>
                </Form-item>
              </Col>
              <Col :span="5">
                <Form-item prop="startTime">
                  <Time-picker format="HH:mm" placeholder="开始时间" :clearable="false"
                    :steps="[1, 30]" :value="timeParam.startTimeStr"
                    @on-change="onChangeStratTime"></Time-picker>
                  </Form-item>
              </Col>
              <Col :span="1"></Col>
              <Col :span="5">
                <Form-item prop="endTime">
                  <Time-picker format="HH:mm" placeholder="结束时间" :clearable="false"
                    :steps="[1, 30]" :value="timeParam.endTimeStr"
                    @on-change="onChangeEndTime"></Time-picker>
                </Form-item>
              </Col>
              <i-col :span="6" >
                <Form-item prop="useDate" >
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder="生效日期"
                               @on-change="onChangeUseDate" :clearable="false" :value="timeParam.useDateStr"></Date-picker>
                </Form-item>
              </i-col>
              <Col :span="2">
                <Button type="info" @click="addOpenedTime">添加</Button>
              </Col>
            </Row>
          </Form-item>
        </Col>

      </Row>
    </Form>
    <Form ref="timeListForm" class="form" :label-width="90"
      :model="{}" :rules="timeListRule">
      <Row>
        <Col :span="22" >
          <Form-item prop="openedTimeList" >
            <Row >
              <div v-for="(item, index) in openedTimeList" :key="item.week">
                <Col offset="1" span="19">
                  <label ><b>时间：{{ item.weekStr }} {{ item.startTimeStr }} - {{ item.endTimeStr }} , &nbsp;&nbsp; 生效日期：{{ item.useDateStr }}</b></label>
                </Col>
                <Col span="3">
                  <Button type="error" size="small" @click="removeOpenedTime(index)">删除</Button>
                </Col>
              </div>
              <div>
                <Col offset="1" span="19">
                  <Button type="error" size="small" icon="ios-trash-outline" @click="deleteAll" :disabled="openedTimeList.length === 0">全部删除</Button>
                </Col>
              </div>
            </Row>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="false" @click="add">保存</Button>
    </div>
  </Modal>
</template>
<script>
  import dates from '../../tools/date/dates'
  import { validateSlots } from '../../tools/timeSlotValidator'

  export default {
    name: 'TchAddOpenedTimeModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      tchId: {
        type: Number
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      let self = this
      return {
        visible: this.value,
        timeParam: {
          week: null,
          startTime: '',
          endTime: '',
          startTimeStr: '',
          endTimeStr: '',
          useDate: '',
          useDateStr: ''
        },
        loadingAdd: false,
        openedTimeList: [],
        existingShortTermSlots: [],
        existingRandomSlots: [],
        timeRule: {
          week: [
            { type: 'integer', required: true, message: '请选择星期', trigger: 'blur' }
          ],
          startTime: [
            { type: 'integer', required: true, message: '请选择开始时间', trigger: 'change' },
            { validator (rule, value, callback, source, options) {
              let endTime = self.timeParam.endTime
              let errors = []
              if (endTime !== '' && value >= endTime) {
                errors.push('开始时间应在结束时间之前 ')
              }
              callback(errors)
            } }
          ],
          endTime: [
            { type: 'integer', required: true, message: '请选择结束时间', trigger: 'change' }
          ],
          useDate: [
            { type: 'integer', required: true, message: '请选择有效日期', trigger: 'change' }
          ],
          openedTime: [
            { validator (rule, value, callback, source, options) {
              let openedTimeList = self.openedTimeList
              let week = self.timeParam.week
              let startTime = self.timeParam.startTime
              let endTime = self.timeParam.endTime
              if (week === '' || startTime === '' || endTime === '' ||
                startTime >= endTime) {
                return
              }
              let errors = []
              openedTimeList.forEach(element => {
                let tmpWeek = element.week
                let tmpStratTime = element.startTime
                let tmpEndTime = element.endTime
                if (week === tmpWeek &&
                  ((tmpStratTime < startTime && tmpEndTime > startTime) ||
                  (tmpStratTime < endTime && tmpEndTime > endTime) ||
                  (tmpStratTime >= startTime && tmpEndTime <= endTime))) {
                  errors.push('添加的时间与 ' + self.$constant.weekZh[week] + ' ' +
                    element.startTimeStr + ' - ' + element.endTimeStr + ' 冲突')
                }
              })
              callback(errors)
            } }
          ],
        },
        timeListRule: {
          openedTimeList: [
            { validator (rule, value, callback, source, options) {
              let openedTimeList = self.openedTimeList
              let errors = []
              if (openedTimeList.length <= 0) {
                errors.push('请添加买断时间')
              }
              callback(errors)
            } }
          ]
        }
      }
    },
    methods: {
      addOpenedTime () {
        let self = this
        self.$refs.timeForm.validate((valid) => {
          if (!valid) {
            return
          }
          let openedTime = {}
          openedTime.week = this.timeParam.week
          openedTime.weekStr = this.$constant.weekZh[this.timeParam.week]
          openedTime.startTime = this.timeParam.startTime
          openedTime.startTimeStr = this.timeParam.startTimeStr
          openedTime.endTime = this.timeParam.endTime
          openedTime.endTimeStr = this.timeParam.endTimeStr
          openedTime.useDate = this.timeParam.useDate
          openedTime.useDateStr = this.timeParam.useDateStr
          openedTime.endDate = 0
          this.openedTimeList.push(openedTime)
          this.timeParam.week = ''
          this.$refs.timeListForm.validate()
        })
      },
      deleteAll () {
        let self = this
        if (self.openedTimeList.length === 0) {
          this.$Message.warning('没有可删除的时间')
          return
        }
        self.$Modal.confirm({
          title: '提示',
          content: '此操作将删除全部买断时间，不可撤销。时间段内有绑定学生时，绑定时段将自动拆分另存。如果需要删除已绑学生时段，请先解绑该学生！',
          width: 380,
          okText: '确定全部删除',
          onOk: () => {
            let listSnapshot = [...self.openedTimeList]
            self.openedTimeList = []
            self.delect(listSnapshot)
            self.$Modal.remove()
          }
        })
      },
      removeOpenedTime (index) {
        let self = this
        let item = self.openedTimeList[index]
        if (!item.id) {
          self.openedTimeList.splice(index, 1)
          return
        }
        self.$Modal.confirm({
          title: '提示',
          content: '此操作将直接删除老师绑定时间，不可撤销。时间段内有绑定学生时，绑定时段将自动拆分另存。如果需要删除已绑学生时段，请先解绑该学生！',
          width: 300,
          okText: '确定删除',
          loading: true,
          onOk: () => {
            self.openedTimeList.splice(index, 1)
            self.delect()
            self.$Modal.remove()
          }
        })
      },
      onChangeStratTime (val) {
        this.timeParam.startTime = this.$dateUtil.getSecondByHm(val)
        this.timeParam.startTimeStr = val
      },
      onChangeEndTime (val) {
        this.timeParam.endTime = this.$dateUtil.getSecondByHm(val)
        this.timeParam.endTimeStr = val
      },
      onChangeUseDate (val) {
        this.timeParam.useDate = val && parseInt(this.$moment(val, 'YYYY-M-D').format('X'))
        this.timeParam.useDateStr = val
      },
      add () {
        let self = this
        self.$refs.timeListForm.validate((valid) => {
          if (!valid) return
//        删除买断时间
          if (self.openedTimeList.length === 0) {
            self.$http.get('/tch/time/deleteBookOpenedTime?tchId=' + self.tchId).then(function (res) {
              if (res && res.data > 0) {
                self.successCallback()
                self.visible = false
                self.$Message.success('删除成功!')
              } else {
                self.$Message.error({
                  content: res.msg || '删除失败',
                  duration: 5
                })
              }
            })
          } else {
            self.openedTimeList.forEach(element => {
              element.tchId = self.tchId
              element.endDate = 0
            })
            self.$http.post('/tch/time/addBookOpenedTime?endDateFlag=0', {}, {
              transformRequest: [function (data, headers) {
                return JSON.stringify(self.openedTimeList)
              }],
              headers: {'Content-Type': 'application/json;charset=utf-8'},
            }).then(function (res) {
//            self.loadingAdd = false
              if (res && res.data > 0) {
                self.successCallback()
                self.visible = false
                self.$Message.success('提交成功!')
              } else {
                self.$Message.error({
                  content: res.msg || '提交失败',
                  duration: 5
                })
              }
            }).catch(function (e) {
//            self.loadingAdd = false
            })
//        })
          }
        })
      },
      delect (rollbackList) {
        let self = this
//        删除买断时间
        if (self.openedTimeList.length === 0) {
          self.$http.get('/tch/time/deleteBookOpenedTime?tchId=' + self.tchId).then(function (res) {
            if (res && res.data > 0) {
              self.successCallback()
              self.visible = false
              self.$Message.success('删除成功!')
            } else {
              if (rollbackList) {
                self.openedTimeList = rollbackList
              }
              self.successCallback()
              self.$Message.error({
                content: res.msg || '操作失败',
                duration: 5
              })
            }
          }).catch(function () {
            if (rollbackList) {
              self.openedTimeList = rollbackList
              self.successCallback()
            }
          })
        } else {
          self.openedTimeList.forEach(element => {
            element.tchId = self.tchId
            element.endDate = 0
          })
          self.$http.post('/tch/time/addBookOpenedTime?endDateFlag=0', {}, {
            transformRequest: [function (data, headers) {
              return JSON.stringify(self.openedTimeList)
            }],
            headers: {'Content-Type': 'application/json;charset=utf-8'},
          }).then(function (res) {
//            self.loadingAdd = false
            if (res && res.data > 0) {
              self.loadTchOpenedTime()
              self.successCallback()
            //  self.visible = false
              self.$Message.success('删除成功')
            } else {
              if (rollbackList) {
                self.openedTimeList = rollbackList
              }
              self.loadTchOpenedTime()
              self.$Message.error({
                content: res.msg || '操作失败',
                duration: 5
              })
            }
          }).catch(function (e) {
            if (rollbackList) {
              self.openedTimeList = rollbackList
            }
//            self.loadingAdd = false
          })
//        })
        }
      },
      loadExistingTimes () {
        let self = this
        self.existingShortTermSlots = []
        self.existingRandomSlots = []
        // 加载已有短期固定时间
        self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=1').then(function (res) {
          if (res && res.data) {
            res.data.forEach(function (e) {
              e.weekStr = self.$constant.weekZh[e.week]
              e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm')
              e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm')
              self.existingShortTermSlots.push(e)
            })
          }
        })
        // 加载已有上课时间
        self.$http.get('/tch/randomOpenedTime?tchId=' + self.tchId).then(function (res) {
          if (res && res.data) {
            res.data.forEach(function (e) {
              e.dayStr = self.$moment.unix(e.day).format('YYYY-MM-DD')
              e.startTimeStr = self.$moment.unix(e.startTime).utc().format('HH:mm')
              e.endTimeStr = self.$moment.unix(e.endTime).utc().format('HH:mm')
              self.existingRandomSlots.push(e)
            })
          }
        })
      },
      loadTchOpenedTime () {
        let self = this
        self.$http.get('/tch/openedTime?tchId=' + self.tchId + '&endDateFlag=0').then(function (res) {
          if (!res || !res.data) {
            return
          }
          self.visible = true
          self.openedTimeList = []
          res.data.forEach(function (element) {
            element.weekStr = self.$constant.weekZh[element.week]
            element.startTimeStr = self.$moment.unix(element.startTime).utc().format('HH:mm')
            element.endTimeStr = self.$moment.unix(element.endTime).utc().format('HH:mm')
            element.useDateStr = dates.formatUnix(element.useDate, 'YYYY-MM-DD')
            self.openedTimeList.push(element)
          })
        })
      },
    },
    watch: {
      value (val) {
        if (val === true) {
          this.openedTimeList = []
          this.loadTchOpenedTime()
          this.loadExistingTimes()
        }
        this.visible = val
      },
      visible (val) {
        if (val === false) {
          this.openedTimeList = []
          this.$refs.timeForm.resetFields()
          this.$refs.timeListForm.resetFields()
          this.timeParam = {
            week: null,
            startTime: '',
            endTime: '',
            startTimeStr: '',
            endTimeStr: '',
            useDate: '',
            useDateStr: ''
          }
        }
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// TchEditOpenedTimeModal.vue?77017980